import { get } from "../../xhr/api";

// export const get_tax_disputes = (data, pageNum, filter) => {
//   const params = {
//     per_page: pageNum,
//     request_number: filter.request_number,
//     tax_type: filter.tax_type,
//     request_status: filter.status,
//     submitted_request_date_from: filter.from_date,
//     submitted_request_date_to: filter.to_date,
//   };
//   console.log('this is params ' , params);


//   return get('api/tax-dispute/requests', { params }, true);
// };

export const get_tax_disputes=(data,pageNum,filter)=> {
  return get('api/tax-dispute/requests?page='+pageNum+
  '&request_number='+filter.request_number+'&tax_type='+filter.tax_type+
  '&submitted_request_date_from='+filter.from_date+'&submitted_request_date_to='+filter.to_date+'&request_status='+filter.status+'&per_page='+filter.per_page,{},true);
}
